import { Value } from '@com-delta-omnichannel/aura';

export const ActivityNullValueMocks: Value[] = [
  {
    amount: '--',
    currency: ''
  }
];

export const ToggleNullValueMocks: Value[] = [
  {
    amount: '',
    currency: ''
  }
];
